import React from 'react';
import ConversationPreview from '../ConversationPreview';
import './index.less';
var ConversationList = function (_a) {
    var conversations = _a.conversations, currentUser = _a.currentUser, selectedConversationSlug = _a.selectedConversationSlug;
    return (React.createElement("ul", { className: "conversationlist" }, conversations.map(function (conversation) { return React.createElement("li", { key: conversation.slug },
        React.createElement(ConversationPreview, { conversation: conversation, currentUser: currentUser, isSelected: conversation.slug === selectedConversationSlug })); })));
};
export default ConversationList;
